import { Excalidraw, MainMenu } from "@excalidraw/excalidraw";
import { useState } from "react";
import { WhiteboardIcon } from "../assets";
import ToolTabs from "../components/ToolTabs";
import styles from "./CodeEditorTab.module.css";

type CodeEditorTabProps = {
	showWhiteboard?: boolean;
	showCodeEditor?: boolean;
	codeEditorKey?: string | null;
};

export default function CodeEditorTab({ showWhiteboard = false, codeEditorKey }: CodeEditorTabProps) {
	const Tabs = [];
	// if (showCodeEditor)
	// 	Tabs.push({
	// 		key: "codeEditor",
	// 		label: "Code Editor",
	// 		color: {
	// 			backgroundColor: "#F9F7FF",
	// 			borderColor: "#E2DCF5",
	// 		},
	// 		icon: <CodeEditorIcon />,
	// 	});
	if (showWhiteboard)
		Tabs.push({
			key: "whiteBoard",
			label: "Whiteboard",
			color: {
				backgroundColor: "#EBF6FD",
				borderColor: "#DEEEFC",
			},
			icon: <WhiteboardIcon />,
		});

	const [tab, setTab] = useState(Tabs[0].key);

	return (
		<div className={styles.wrapper}>
			<ToolTabs tabs={Tabs} onChange={setTab} />

			{tab === "whiteBoard" && (
				<Excalidraw>
					<MainMenu>
						<MainMenu.Group title="Main Menu">
							<MainMenu.DefaultItems.ClearCanvas />
							<MainMenu.DefaultItems.ChangeCanvasBackground />
						</MainMenu.Group>
					</MainMenu>
				</Excalidraw>
			)}
			{tab === "codeEditor" && (
				<iframe
					id="iframe"
					src={`https://rustpad.io/#${codeEditorKey}`}
					width="100%"
					height="100%"
					style={{ border: 0 }}
				/>
			)}
		</div>
	);
}
